<template>
    <div role="tabcard" class="tab-pane" id="crew">
        <crew-list :user="user"></crew-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            
        },

        methods: {
           
        }
    }
</script>
